/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react';
import { Spin } from 'shared/components';
import ServiceTable from './ServiceTable';
import TotalPriceTable from './TotalPriceTable';

interface HaierCostingTableProps {
  costingData: any;
}
const HaierCostingTable: React.FC<HaierCostingTableProps> = (props) => {
  const { costingData } = props;

  let content = <Spin />;
  if (costingData) {
    content = (
      <div style={{ overflowX: 'auto' }}>
        <ServiceTable haierCostData={costingData} />
        <TotalPriceTable haierCostData={costingData} />
      </div>
    );
  }

  return content;
};

export default HaierCostingTable;
